import $ from 'jquery';

$('.reveal--search').on('open.zf.reveal', function () {
  window.setTimeout(function () {
    document.querySelector('.js-form-item-search .form-search').focus();
  }, 500);
});
